import styled from 'styled-components';

export const HeaderWrapper = styled.div<{ $unfixedHeight?: boolean }>`
    display: flex;
    gap: 14px;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0;
    margin: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        align-items: center;
        justify-content: flex-start;
        height: ${({ $unfixedHeight }) => ($unfixedHeight ? 'unset' : '60px')};
    }
`;

export const HeaderBar = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 50px;
        align-items: center;
        justify-content: flex-start;
    }
`;

export const Title = styled.div`
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.03em;
    color: #ffffff;

    font-size: 26px;

    span {
        font-weight: 400;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 34px;
    }
`;
